export enum Location {
    VARIATIONS = 'Variations',
    BANNER = 'Mweb to web banner',
    EXPLAINER_MODAL = 'Explainer Modal',
}
